/**
 * TipTap emits '<p></p>' (or similar tag soup with no real content) for an
 * empty editor, which is truthy in JS. This strips tags/whitespace so we can
 * tell "no content" apart from "user typed something" and fall back properly.
 * @param {string} html
 * @returns {boolean}
 */
export function isHtmlEmpty(html) {
  if (!html) {
    return true
  }
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim()
  return text.length === 0
}
